import React, { useRef } from 'react';
import { SyndicatedContentProviderNames, SyndicatedContentProvider } from '../syndicatedContent/types';
import { SYNDICATED_CONTENT_PROVIDER_NAME } from '../syndicatedContent/constants';
import { styles } from './SyndicatedContent.css';

const SyndicatedInnerContent = ({ provider }: { provider: SyndicatedContentProviderNames | null }): JSX.Element => {
  switch (provider) {
    case SYNDICATED_CONTENT_PROVIDER_NAME.CONTENT_DRIVER:
      return <div id="content-driver__content"></div>;

    case SYNDICATED_CONTENT_PROVIDER_NAME.FLIX:
      return <div id="flix-wrapper"></div>;

    case SYNDICATED_CONTENT_PROVIDER_NAME.SYNDIGO:
      return <div id="syndi_inline"></div>;

    case SYNDICATED_CONTENT_PROVIDER_NAME.ONE_WORLD_SYNC:
      return <div id="ccs-inline-content"></div>;

    default:
      return <></>;
  }
};

type SyndicatedContentProps = {
  providers: Array<SyndicatedContentProvider | null>;
};

const SyndicatedContent = ({ providers }: SyndicatedContentProps): JSX.Element => {
  const syndicatedContentRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={styles.root} ref={syndicatedContentRef}>
      {providers.map(provider => {
        if (!provider?.type) return null;
        return <SyndicatedInnerContent key={provider.type} provider={provider.type} />;
      })}
    </div>
  );
};

SyndicatedContent.displayName = 'SyndicatedContent';

export default SyndicatedContent;
